var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"google-translate-btn",class:{ ready: _vm.isReady }},[_c('button',{attrs:{"accesskey":"T"},on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[_vm._v("Translate")])])])}
var staticRenderFns = []

export { render, staticRenderFns }